import { _ } from "../../core/polyglot/polyglot.js";
import accountingDocument from "../shared/accountingDocument.js";
import reportDocumentsPanelWidget from "./reportDocumentsPanelWidget.js";
import session from "../../core/session.js";

/**
 * `reportArchiveDocument` displays two panel of reports for the
 * currently active fiscal year: income statements and balance
 * reports
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} reportArchiveDocument
 */
function reportArchiveDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = accountingDocument(spec, my);

	that.title = _("Report Archive");
	that.subtitle = _("Income Statements and Balance Sheets");

	that.help = function () {
		return [
			{
				title: _("Report archive"),
				content: _(
					"This is your company's report archive where all historical periods balance sheets and income statements are shown. All reports are generated automatically and do not need be created each time a new period of booking has been uploaded.",
				),
			},
			{
				title: _("Income Statement"),
				content: _(
					"Click an icon to jump to an income statement report for a specific period.",
				),
				element: "income-statements",
			},
			{
				title: _("Balance Sheets"),
				content: _(
					"Similarly, click an icon to jump to a balance sheet report for a specific period.",
				),
				element: "balance-sheets",
			},
		];
	};

	my.incomeStatementsPanel = reportDocumentsPanelWidget({
		type: "income-statement",
		currentPeriod: session.getPeriod(),
	});

	my.balanceSheetsPanel = reportDocumentsPanelWidget({
		type: "balance-sheet",
		currentPeriod: session.getPeriod(),
	});

	that.isActionsMenuMobileOnly = function () {
		return true;
	};

	my.renderContentOn = function (html) {
		html.render(
			my.section({
				content: [my.renderIncomeStatementsOn, my.renderBalanceSheetOn],
			}),
		);
	};

	my.renderIncomeStatementsOn = function (html) {
		html.div(
			{ class: "col-lg-6", "data-help": "income-statements" },
			html.h2(_("Income statements")),
			my.incomeStatementsPanel,
		);
	};

	my.renderBalanceSheetOn = function (html) {
		html.div(
			{ class: "col-lg-6", "data-help": "balance-sheets" },
			html.h2(_("Balance sheets")),
			my.balanceSheetsPanel,
		);
	};

	return that;
}

export default reportArchiveDocument;
